<template>
<div>
    <h3 style="font-size: 40px;">About</h3>
    <div class="hello">
        <div class="box">
            <div class="imgBx">
                <img src="../assets/images/1.png">
            </div>
            <div class="content">
                <div>
                    <h2>Image Title</h2>
                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Commodi accusamus molestias quidem iusto.
                    </p>
                </div>
            </div>
        </div>
        <div class="box">
            <div class="imgBx">
                <img src="../assets/images/2.png">
            </div>
            <div class="content">
                <div>
                    <h2>Image Title</h2>
                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Commodi accusamus molestias quidem iusto.
                    </p>
                </div>
            </div>
        </div>
        <div class="box">
            <div class="imgBx">
                <img src="../assets/images/3.png">
            </div>
            <div class="content">
                <div>
                    <h2>Image Title</h2>
                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Commodi accusamus molestias quidem iusto.
                    </p>
                </div>
            </div>
        </div>
        <div class="box">
            <div class="imgBx">
                <img src="../assets/images/4.png">
            </div>
            <div class="content">
                <div>
                    <h2>Image Title</h2>
                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Commodi accusamus molestias quidem iusto.
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<style>
.hello {
    position: relative;
    width: 100%;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    transform-style: preserve-3d;
    perspective: 500px;
    margin: auto;
}

.hello .box {
    position: relative;
    width: 275px;
    height: 275px;
    background: #000;
    transition: 0.5s;
    transform-style: preserve-3d;
    overflow: hidden;
    margin-right: 15px;
    margin-top: 45px;
}

.hello:hover .box {
    transform: rotateY(25deg);
}

.hello .box:hover~.box {
    transform: rotateY(-25deg);
}

.hello .box:hover {
    transform: rotateY(0deg) scale(1.25);
    z-index: 1;
    box-shadow: 0 25px 40px rgba(0, 0, 0, 0.5);
}

.hello .box .imgBx {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

.hello .box .imgBx:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(180deg, rgb(133, 203, 241), #817a7a);
    z-index: 1;
    opacity: 0;
    transition: 0.5s;
    mix-blend-mode: multiply;
}

.hello .box:hover .imgBx:before {
    opacity: 1;
}

.hello .box .imgBx img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
}

h3 {
    color: #000;
    position: relative;
    text-decoration: none;
    text-align: center;
    /* Center the text */
}

h3::before {
    background: hsl(45 100% 70%);
    content: "";
    inset: 0;
    position: absolute;
    transform: scaleX(0);
    transform-origin: right;
    transition: transform 0.5s ease-in-out;
    z-index: -1;
}

h3:hover::before {
    transform: scaleX(1);
    transform-origin: left;
}
</style>
